import script from "./ProductSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSelect.vue?vue&type=script&setup=true&lang=ts"

import "./ProductSelect.vue?vue&type=style&index=0&id=0db2bd9d&lang=less&scoped=true"

import exportComponent from "/Users/ivan/Codes/ripple/wfj-vto-hub/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0db2bd9d"]])

export default __exports__